<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height"
			@show="modal_onshow" show-footer @hide="modal_onhide" destroy-on-close>
			<template #default>
				<el-tabs v-model="activeName" type="card" >
					<el-tab-pane label="品类目标" name="groupkpi">
						<groupkpi :nodeid="nodeid" />	
					</el-tab-pane>
					<el-tab-pane label="单品目标" name="spukpi">
						<spukpi :nodeid="nodeid" />	
					</el-tab-pane>
				</el-tabs>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" ></vxe-button>
			</template>
		</vxe-modal>
		
		
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import groupkpi from './groupkpi/index.vue'
	import spukpi from './spukpi/index.vue'
	//import staff from '@_system/components/formcomponents/common/select/staff/select.vue'
	export default {
		mixins: [listMixins, modalMixins],
		props: {
			nodeid: {
				default: () => {
					return 0
				}
			},
			currentItem: {
				default: () => {
					return null
				}
			},
			sourceoperatedata: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				activeName: 'groupkpi',
				parentdata: [],
				modal_title: 'kpi配置',
				modal_width: 1200,
				modal_height: 600,
				form: {
					shopName: '',
					parentid: 0,
					adminstaffid: null
				},
				tableData:[]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			modal_onshow() {
				this.parentdata = this.sourceoperatedata.filter((item) => {
					return item.id != this.nodeid
				})
				this.form = {
					shopName: '',
					parentid: 0,
					adminstaffid: null
				}
				if (this.currentItem) {
					if (this.nodeid) {
						for (let i in this.form) {
							this.form[i] = this.currentItem[i]
						}
					} else {
						this.form.parentid = this.currentItem.id
					}
				}

			},
			staffsubmit(e) {
				this.form.adminstaffid = e.data

			},
			submit() {
				this.form.parentid = Math.max(0, this.form.parentid)
				if (!this.nodeid) {
					this.$api.BIshopgoods.addgroup(this.form).then(() => {
						this.modal_cancel()
						this.$message.success('操作成功')
						this.$emit('addsuccess')
					})
				} else {
					this.form.id = this.nodeid
					this.$api.BIshopgoods.addgroup(this.form).then(() => {
						this.modal_cancel()
						this.$message.success('操作成功')
						this.$emit('addsuccess')
					})
				}
			},
			reset() {
				//this.init()
			}
		},
		components: {
			groupkpi,
			spukpi
		}
	}
</script>